/** مفاتيح breakdown في استجابة enthusiasm/daily */
export const ENTHUSIASM_BREAKDOWN_KEYS = ['dailyExercises', 'flashAnzan', 'flashCard', 'games'];

/** الهدف اليومي الافتراضي لنقاط الحماسة (يُستخدم إن لم يُرجع الـ API حداً) */
export const ENTHUSIASM_DAILY_GOAL_POINTS = 36;

export function isActivityBlockDone(block) {
  if (!block || typeof block !== 'object') return false;
  const sub = Number(block.subtotal ?? 0);
  const part = Number(block.participation ?? 0);
  const sessions = Number(block.sessionCount ?? 0);
  return sub > 0 || part > 0 || sessions > 0;
}

export function enthusiasmCompletedActivityCount(breakdown) {
  if (!breakdown || typeof breakdown !== 'object') return 0;
  return ENTHUSIASM_BREAKDOWN_KEYS.filter((k) => isActivityBlockDone(breakdown[k])).length;
}

/** حد أقصى يومي للنقاط إن وُجد في الـ API */
export function pickDailyMaxPoints(data) {
  if (!data || typeof data !== 'object') return null;
  const n = (v) => {
    const x = Number(v);
    return Number.isFinite(x) && x > 0 ? x : null;
  };
  return (
    n(data.dailyMaxPoints) ??
    n(data.dailyMax) ??
    n(data.maxDailyPoints) ??
    n(data.maxPoints) ??
    n(data.dailyGoal) ??
    n(data.dailyTarget) ??
    null
  );
}

/** الحد اليومي الفعلي: من الـ API أو 36 */
export function getEffectiveDailyMaxPoints(dailyPayload) {
  const fromApi = pickDailyMaxPoints(dailyPayload);
  return fromApi != null ? fromApi : ENTHUSIASM_DAILY_GOAL_POINTS;
}

/**
 * نسبة مئوية 0–100: نقاط اليوم ÷ الهدف اليومي (افتراضياً 36).
 */
export function computeEnthusiasmProgressPercent(total, dailyPayload) {
  const t = Number(total);
  const totalNum = Number.isFinite(t) && t >= 0 ? t : 0;
  const max = getEffectiveDailyMaxPoints(dailyPayload);
  return Math.min(100, Math.round((totalNum / max) * 1000) / 10);
}
